<template>
    <div class="announcement-audit">
        <!-- 页面标题 -->
        <div class="page-header">
            <h2 class="page-title">招标公告审核</h2>
            <span
                class="warning-text">注意:因招标公告及相关数据,推送至河北省招标投标公共服务平台或河北省招标投标行政监督平台(招管通)需要一定时间,为了不影响招标公告的发布,建议16:30之前进行审核。</span>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <label class="search-label">公告名称:</label>
                <el-input v-model="searchForm.announcementName" placeholder="请输入公告名称" class="search-input" clearable />
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
                    搜索
                </el-button>
            </div>
            <!-- 审核状态切换按钮 -->
            <div class="audit-status-tabs">
                <div class="tab-buttons">
                    <button 
                        class="tab-button" 
                        :class="{ active: currentAuditStatus === 'unaudited' }"
                        @click="switchAuditStatus('unaudited')"
                    >
                        未审核公告
                    </button>
                    <button 
                        class="tab-button" 
                        :class="{ active: currentAuditStatus === 'audited' }"
                        @click="switchAuditStatus('audited')"
                    >
                        已审核公告
                    </button>
                </div>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" >
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="tenderNoticeName" label="公告名称"  show-overflow-tooltip />
                <el-table-column prop="tenderNoticeCode" label="公告编号" align="center" show-overflow-tooltip />
                <el-table-column prop="noticeNature" label="公告性质" align="center">
                    <template slot-scope="scope">
                        {{ noticeNatureDict[scope.row.noticeNature] || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="noticeType" label="公告类型"  align="center">
                    <template slot-scope="scope">
                        {{ noticeTypeDict[scope.row.noticeType] || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间"  align="center" />
                <el-table-column prop="noticeSendTime" label="公告发布时间" align="center" />
                <el-table-column prop="createBy" label="创建人"  align="center" />
                <el-table-column prop="auditTime" label="审核时间"  align="center" />
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        {{ statusDict[scope.row.status] || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleAudit(scope.row)" class="action-btn" v-if="currentAuditStatus === 'unaudited'">
                            审核
                        </el-button>
                        <el-button type="text" size="small" @click="handleViewStatus(scope.row)" class="action-btn" >
                            查看状态
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 详情弹窗 -->
        <el-dialog title="招标公告详情" :visible.sync="detailDialogVisible" width="80%" :close-on-click-modal="false"
            :append-to-body="true" class="detail-dialog">
            <div class="detail-content" v-if="currentDetail">
                <el-row :gutter="20">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <div class="detail-item">
                            <span class="detail-label">公告名称:</span>
                            <span class="detail-value">{{ currentDetail.tenderNoticeName || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告编码:</span>
                            <span class="detail-value">{{ currentDetail.tenderNoticeCode || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告发布时间:</span>
                            <span class="detail-value">{{ currentDetail.noticeSendTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告结束时间:</span>
                            <span class="detail-value">{{ currentDetail.noticeEndTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">招标文件获取开始时间:</span>
                            <span class="detail-value">{{ currentDetail.biddingDocumentAcquisitionStartTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">招标文件获取结束时间:</span>
                            <span class="detail-value">{{ currentDetail.biddingDocumentAcquisitionEndTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">招标文件获取范围:</span>
                            <span class="detail-value">{{
                                biddingDocumentAcquisitionScopeDict[currentDetail.biddingDocumentAcquisitionScope] || '-'
                            }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">招标文件获取方法:</span>
                            <span class="detail-value">{{ currentDetail.biddingDocumentAcquisitionMethod || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">投标文件递交截止时间:</span>
                            <span class="detail-value">{{ currentDetail.bidDocumentSubmissionDeadline || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">投标文件递交方法:</span>
                            <span class="detail-value">{{ currentDetail.bidDocumentSubmissionMethod || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">是否涉密:</span>
                            <span class="detail-value">{{ isConfidentialDict[currentDetail.isConfidential] || '-' }}</span>
                        </div>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">
                        <div class="detail-item">
                            <span class="detail-label">公告性质:</span>
                            <span class="detail-value">{{ noticeNatureDict[currentDetail.noticeNature] || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告类型:</span>
                            <span class="detail-value">{{ noticeTypeDict[currentDetail.noticeType] || '-' }}</span>
                        </div>
                        <!-- <div class="detail-item">
                            <span class="detail-label">公告发布媒体:</span>
                            <span class="detail-value">{{ currentDetail.noticeMedia || '-' }}</span>
                        </div> -->
                        <div class="detail-item">
                            <span class="detail-label">原公告编号:</span>
                            <span class="detail-value">{{ currentDetail.originalNoticeCode || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">发布状态:</span>
                            <span class="detail-value">{{ statusDict[currentDetail.status] || '-' }}</span>
                        </div>
                        <!-- <div class="detail-item">
                            <span class="detail-label">创建人:</span>
                            <span class="detail-value">{{ currentDetail.createBy || '-' }}</span>
                        </div> -->
                        <div class="detail-item">
                            <span class="detail-label">创建时间:</span>
                            <span class="detail-value">{{ currentDetail.createTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">修改人:</span>
                            <span class="detail-value">{{ currentDetail.modifyBy || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">修改时间:</span>
                            <span class="detail-value">{{ currentDetail.modifyTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">审核人:</span>
                            <span class="detail-value">{{ currentDetail.auditBy || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">审核时间:</span>
                            <span class="detail-value">{{ currentDetail.auditTime || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">审核意见:</span>
                            <span class="detail-value">{{ currentDetail.auditOpinion || '-' }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">备注:</span>
                            <span class="detail-value">{{ currentDetail.remark || '-' }}</span>
                        </div>
                    </el-col>
                </el-row>

                <!-- 公告内容 -->
                <div class="detail-item" style="margin-top: 20px;">
                    <span class="detail-label">公告内容:</span>
                    <div class="detail-content-text">
                        <div v-html="currentDetail.noticeContent || '-'" class="notice-content"></div>
                    </div>
                </div>

                <!-- 审核区域 -->
                <div class="audit-section" v-if="currentAuditStatus === 'unaudited'">
                    <div class="audit-form">
                        <div class="audit-item">
                            <span class="audit-label">审核结果:</span>
                            <el-radio-group v-model="auditForm.auditResult">
                                <el-radio :label="1">通过</el-radio>
                                <el-radio :label="2">驳回</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="audit-item" v-if="auditForm.auditResult === 2">
                            <span class="audit-label">审核意见:</span>
                            <el-input
                                v-model="auditForm.auditOpinion"
                                type="textarea"
                                :rows="4"
                                placeholder="请输入审核意见"
                                maxlength="500"
                                show-word-limit
                                class="audit-textarea"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关闭</el-button>
                <el-button 
                    type="primary" 
                    @click="handleSubmitAudit" 
                    v-if="currentAuditStatus === 'unaudited'"
                    :disabled="auditForm.auditResult === 2 && !auditForm.auditOpinion.trim()"
                >
                    提交审核
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTenderNoticeAuditList, getTenderNoticeDetailForAudit, checkTenderNotice } from '@/api/agent/api'
export default {
    name: 'AnnouncementAudit',
    data() {
        return {
            loading: false,
            currentAuditStatus: 'unaudited', // 当前审核状态：unaudited-未审核，audited-已审核
            searchForm: {
                announcementName: ''
            },
            // 数据字典
            noticeNatureDict: {
                1: '正常公告',
                2: '变更公告'
            },
            noticeTypeDict: {
                1: '招标公告',
                2: '资格预审公告',
                3: '中标公告',
                9: '其他'
            },
            statusDict: {
                0: '暂存',
                1: '提交',
                2: '退回',
                9: '发布'
            },
            biddingDocumentAcquisitionScopeDict: {
                1: '公告期',
                2: '文件获取期'
            },
            isConfidentialDict: {
                0: '不包含',
                1: '包含'
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 2
            },
            // 详情弹窗相关
            detailDialogVisible: false,
            currentDetail: null,
            // 审核表单
            auditForm: {
                auditResult: 1, // 1-通过，2-驳回
                auditOpinion: ''
            }
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 加载数据
        loadData() {
            this.loading = true
            this.getTenderNoticeAuditList()
        },
        // 获取招标公告审核列表
        getTenderNoticeAuditList() {
            const status = this.currentAuditStatus === 'unaudited' ? 1 : 9; // 1-未审核，9-已审核
            const params = {
                status,
                tenderNoticeName: this.searchForm.announcementName,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize
            }
            
            getTenderNoticeAuditList(params).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.$message.error(res.message || '获取数据失败')
                    this.tableData = []
                    this.pagination.total = 0
                }
                this.loading = false
            }).catch(error => {
                console.error('获取数据失败:', error)
                this.$message.error('获取数据失败')
                this.loading = false
            })
        },

        // 切换审核状态
        switchAuditStatus(status) {
            this.currentAuditStatus = status
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 查看详情
        async handleViewDetails(row) {
            try {
                const res = await getTenderNoticeDetailForAudit({ tenderNoticeCode: row.tenderNoticeCode })
                if (res.code === 200) {
                    this.currentDetail = res.data
                    this.detailDialogVisible = true
                    // 重置审核表单
                    this.resetAuditForm()
                } else {
                    this.$message.error('获取公告详情失败')
                }
            } catch (error) {
                console.error('获取公告详情失败:', error)
                this.$message.error('获取公告详情失败')
            }
        },

        // 审核
        handleAudit(row) {
            this.handleViewDetails(row)
        },

        // 查看状态
        handleViewStatus(row) {
            this.handleViewDetails(row)
        },

        // 重置审核表单
        resetAuditForm() {
            this.auditForm = {
                auditResult: 1,
                auditOpinion: ''
            }
        },

        // 提交审核
        async handleSubmitAudit() {
            if (this.auditForm.auditResult === 2 && !this.auditForm.auditOpinion.trim()) {
                this.$message.warning('驳回时必须填写审核意见')
                return
            }

            try {
                const params = {
                    tenderNoticeCode: this.currentDetail.tenderNoticeCode,
                    status: this.auditForm.auditResult === 1 ? 9 : 2, // 1-通过对应9，2-驳回对应2
                    auditOpinion: this.auditForm.auditOpinion
                }

                const res = await checkTenderNotice(params)
                if (res.code === 200) {
                    this.$message.success('审核提交成功')
                    this.detailDialogVisible = false
                    this.loadData() // 重新加载数据
                } else {
                    this.$message.error(res.message || '审核提交失败')
                }
            } catch (error) {
                console.error('审核提交失败:', error)
                this.$message.error('审核提交失败')
            }
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/agent-child-page-styles.less';

.agent-child-page-styles(announcement-audit);

.page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .warning-text {
        margin-left: 10px;
        color: #F56C6C;
        font-size: 14px;
        font-weight: 500;
    }
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    margin-bottom: 20px;
    transition: box-shadow 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .search-form {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 20px;
        flex-wrap: wrap;

        .search-label {
            font-size: 14px;
            color: #606266;
            white-space: nowrap;
            font-weight: 500;
        }

        .search-input {
            width: 240px;
        }

        .search-btn {
            height: 36px;
            padding: 0 24px;
        }
    }

    .audit-status-tabs {
        display: flex;
        justify-content: flex-start;
        
        .tab-buttons {
            border-radius: 6px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

            .tab-button {
                padding: 10px 24px;
                border: none;
                background-color: #fff;
                color: #606266;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.3s ease;
                border-right: 1px solid #e4e7ed;
                outline: none;

                &:first-child {
                    border-top-left-radius: 6px;
                    border-bottom-left-radius: 6px;
                }

                &:last-child {
                    border-top-right-radius: 6px;
                    border-bottom-right-radius: 6px;
                    border-right: none;
                }

                &:hover {
                    background-color: #f5f7fa;
                    transform: translateY(-1px);
                }

                &.active {
                    background-color: #409EFF;
                    color: #fff;
                    border-color: #409EFF;

                    &:hover {
                        background-color: #409EFF;
                    }
                }
            }
        }
    }
}

// 表格样式优化
:deep(.el-table) {
    .el-table__header {
        th {
            background-color: #fff;
            color: #333;
            font-weight: 600;
        }
    }

    .el-table__body {
        tr {
            &:hover {
                background-color: #f5f7fa;
            }
        }
    }
}

// 分页样式优化
:deep(.el-pagination) {
    .el-pagination__total {
        margin-right: 20px;
    }

    .el-pagination__sizes {
        margin-right: 20px;
    }

    .el-pager li {
        &.active {
            background-color: #409EFF;
            color: #fff;
        }
    }

    .el-pagination__jump {
        margin-left: 20px;
    }
}

// 详情弹窗样式
.detail-dialog {
    .el-dialog__body {
        padding: 20px;
    }

    .detail-content {
        .detail-item {
            display: flex;
            margin-bottom: 15px;
            align-items: flex-start;

            .detail-label {
                color: #666;
                font-weight: 500;
                min-width: 200px;
                flex-shrink: 0;
                margin-right: 10px;
                text-align: right;
            }

            .detail-value {
                color: #333;
                flex: 1;
                word-break: break-all;
            }

            .detail-content-text {
                flex: 1;
                margin-top: 5px;
            }

            .notice-content {
                max-height: 300px;
                overflow-y: auto;
                padding: 10px;
                border: 1px solid #e4e7ed;
                border-radius: 4px;
                background-color: #fafafa;
                line-height: 1.6;
            }
        }
    }

    .audit-section {
        margin-top: 30px;
        padding: 20px;
        background-color: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;

        .audit-form {
            .audit-item {
                display: flex;
                align-items: flex-start;
                margin-bottom: 20px;

                .audit-label {
                    color: #666;
                    font-weight: 500;
                    min-width: 100px;
                    flex-shrink: 0;
                    margin-right: 15px;
                }

                .audit-textarea {
                    flex: 1;
                    max-width: 400px;
                }
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding: 10px 0;
    }
}
</style>